import { BlockFilters } from '@reliance/types/filters/BlockFilters';
import { BlockHistory } from '@reliance/types/models/Block';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export type PaginatedBlocksResponse = {
  page: number
  perPage: number
  total: number
  totalPages: number
  blocks: (BlockHistory & { type: string })[]
  supportingData: any
}

export const useBlocks = (filters?: BlockFilters) => {
  return useAsync<PaginatedBlocksResponse>(
    () => filters ? api.get<PaginatedBlocksResponse>('/block', { params: filters }).then(r => r.data) : null,
    [filters]
  );
};

export const useBlocksForFacility = (facilityId: number, filters?: BlockFilters) => {
  return useAsync<PaginatedBlocksResponse>(
    () => filters ? api.get<PaginatedBlocksResponse>('/block', { params: { ...filters, facilityId } }).then(r => r.data) : null,
    [filters]
  );
};

export const useBlocksForPhoneNumber = (phoneNumber: string, filters?: BlockFilters) => {
  return useAsync<PaginatedBlocksResponse>(
    () => filters ? api.get<PaginatedBlocksResponse>('/block', { params: { ...filters, phoneNumber } }).then(r => r.data) : null,
    [filters]
  );
};
